import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Translates } from '../../ph-simple-table/translates';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';

import { SHARED_MODULES } from '../../../../shared.';

export const ELEMENT = new InjectionToken<string>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

@Component({
    selector: 'app-string-dtype',
    templateUrl: 'string-dtype.component.html',
    styleUrls: ['string-dtype.component.scss'],
	imports: [SHARED_MODULES],
    standalone: true
})
export class StringDtypeComponent implements OnInit {
	displayValue: string = '';
	element: string;
	isTooltip: boolean = false;
	translates = Translates;

	constructor(
		@Inject(ELEMENT) private elementInjected: IInjectedElementDtype<string>,
		private translate: TranslateService
	) {}

	ngOnInit(): void {
		this.element = this.elementInjected.element;
		this.isTooltip = this.elementInjected.isTooltip;
		this.displayValue = this.element || '-';

		if (this.elementInjected.isTranslate && this.translates[this.element])
			this.translate
				.get(this.translates[this.element])
				.subscribe((value: string) => this.displayValue = value);
	}
}
